// faq-transform.js
(function () {
  // Find the FAQ heading
  const faqHeading = [...document.querySelectorAll('h1,h2,h3,h4,h5,h6')]
    .find(h => /^faq(s)?$/i.test(h.textContent.trim()));
  if (!faqHeading) return;

  // Skip if collapsible wrapper already exists
  const nextEl = faqHeading.nextElementSibling;
  if (nextEl && nextEl.classList.contains('collapsible-content__items')) return;

  const isEl = n => n && n.nodeType === 1;
  const isQH3 = n => isEl(n) && n.tagName === 'H3' && n.textContent.trim().endsWith('?');
  const isNonQH3 = n => isEl(n) && n.tagName === 'H3' && !n.textContent.trim().endsWith('?');

  const ICON_SVG = `
<svg width="40" height="40" viewBox="0 0 40 40" class="icon icon-arrow" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M30 16L20 26L10 16L11.3333 14.6667L20 23.3333L28.6667 14.6667L30 16Z" fill="currentColor"/>
</svg>
`;

  const wrapper = document.createElement('div');
  wrapper.className = 'collapsible-content__items main-article';

  let node = faqHeading.nextSibling;
  let index = 0;

  while (node) {
    if (isNonQH3(node)) break;

    if (isQH3(node)) {
      const h3 = node;
      const questionText = h3.textContent.trim().replace(/^["'\s]+|["'\s]+$/g, '');
      index += 1;
      const id = `faq-${index}`;

      // collect answer nodes
      const answerNodes = [];
      let next = h3.nextSibling;
      while (next && !isQH3(next) && !isNonQH3(next)) {
        const toMove = next;
        next = next.nextSibling;
        if ((toMove.nodeType === 3 && toMove.textContent.trim()) || isEl(toMove)) {
          answerNodes.push(toMove);
        }
      }

      // build item
      const item = document.createElement('div');
      item.className = 'collapsible-content__item';

      const btn = document.createElement('button');
      btn.className = 'collapsible-content__toggle focus-inset button--unstyled';
      btn.setAttribute('aria-label', questionText);
      btn.setAttribute('aria-controls', id);
      btn.setAttribute('aria-expanded', 'false');

      const group = document.createElement('div');
      group.className = 'collapsible-content__toggle-group';
      const q = document.createElement('h3');
      q.className = 'collapsible-content__question h3';
      q.textContent = questionText;
      group.appendChild(q);

      const icon = document.createElement('div');
      icon.className = 'collapsible-content__icon';
      icon.innerHTML = ICON_SVG;

      btn.appendChild(group);
      btn.appendChild(icon);

      const answer = document.createElement('div');
      answer.className = 'collapsible-content__answer';
      answer.id = id;

      const inner = document.createElement('div');
      inner.className = 'collapsible-content__answer-inner richtext__content';
      answerNodes.forEach(n => inner.appendChild(n));
      answer.appendChild(inner);

      item.appendChild(btn);
      item.appendChild(answer);
      wrapper.appendChild(item);

      // remove original question h3
      h3.remove();

      node = next;
      continue;
    }

    node = node.nextSibling;
  }

  if (wrapper.childNodes.length) {
    faqHeading.parentNode.insertBefore(wrapper, faqHeading.nextSibling);
  }
})();
